module.exports = __webpack_public_path__ + "static/img/kcom.1b7f4c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/kcom.jpg
// module id = gTft
// module chunks = 15